export function createInvalidArgFactory(arg, name) {
  return (dispatch, options) => {
    throw new Error("Invalid value of type ".concat(typeof arg, " for ").concat(name, " argument when connecting component ").concat(options.wrappedComponentName, "."));
  };
}